module.exports = __webpack_public_path__ + "img/15.ed8e1457.png";